var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 16,
    fill: "#F4E9FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6244_56035)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.1646 15.9064L18.9896 26.1679C17.8084 27.0344 17.0996 28.3798 17.0996 29.8164V50.3393C17.0996 52.8477 19.2259 54.9 21.8246 54.9H50.1746C52.7734 54.9 54.8996 52.8477 54.8996 50.3393V29.8164C54.8996 28.3798 54.1909 27.0344 53.0096 26.1679L38.8346 15.9064C37.1572 14.6979 34.842 14.6979 33.1646 15.9064ZM30.684 35.5172C32.3141 35.5172 33.6371 36.7942 33.6371 38.3676C33.6371 39.9411 32.3141 41.218 30.684 41.218C29.0539 41.218 27.7309 39.9411 27.7309 38.3676C27.7309 36.7942 29.0539 35.5172 30.684 35.5172ZM46.6309 48.059C45.9694 48.059 45.4496 47.5574 45.4496 46.9189V44.6385H26.5496V46.9189C26.5496 47.5574 26.0299 48.059 25.3684 48.059C24.7069 48.059 24.1871 47.5574 24.1871 46.9189V33.2369C24.1871 32.5984 24.7069 32.0967 25.3684 32.0967C26.0299 32.0967 26.5496 32.5984 26.5496 33.2369V42.3582H34.8184V35.5172C34.8184 34.8787 35.3381 34.3771 35.9996 34.3771H43.0871C45.6859 34.3771 47.8121 36.4294 47.8121 38.9377V46.9189C47.8121 47.5574 47.2924 48.059 46.6309 48.059Z",
    fill: "#A172D2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6244_56035"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50.4,
    height: 50.4,
    fill: "white",
    transform: "translate(10.7998 10.7998)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBed);
export default __webpack_public_path__ + "static/media/bed.45d8cf2af3e557b7225980935304cd04.svg";
export { ForwardRef as ReactComponent };